import { render, staticRenderFns } from "./AssetsAllocateDisplay.vue?vue&type=template&id=28745e11&scoped=true&"
import script from "./AssetsAllocateDisplay.vue?vue&type=script&lang=js&"
export * from "./AssetsAllocateDisplay.vue?vue&type=script&lang=js&"
import style0 from "./AssetsAllocateDisplay.vue?vue&type=style&index=0&id=28745e11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28745e11",
  null
  
)

export default component.exports